import imageUrlBuilder from '@sanity/image-url';
import myConfiguredSanityClient from '../../config/sanity';

const builder = imageUrlBuilder(myConfiguredSanityClient);

export function urlFor(source) {
  return builder.image(source);
}

export const detectMobile = {
  Android() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows() {
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },
  any() {
    return (detectMobile.Android() || detectMobile.BlackBerry() || detectMobile.iOS() || detectMobile.Opera() || detectMobile.Windows());
  },
};

export default null;

export const pageMeta = {
  mainTitle: 'Aman, Bunga Tinggi dan Proses Mudah',
  mainDesc: 'Deposito mudah mulai dari sekarang di DepositoBPR by Komunal, '
  + 'Suku bunga tinggi s/d 6.75% dijamin LPS. Tunggu apa lagi? Yuk #SimpananRasaInvestasi',
  faqTitle: 'FAQ, Apa itu BPR? Apakah Deposito BPR aman?',
  faqDesc: 'Punya pertanyaan seputar produk dan layanan Komunal mengenai Deposito BPR? Kunjungi kami, Komunal siap membantu Anda',
  peluangTitle: 'Peluang Deposito, Temukan pilihan Deposito Anda',
  peluangDesc: 'Temukan Peluang Deposito Anda, Tenor Mulai dari 1 bulan s/d 12 bulan. Bunga Tinggi, Aman dan Proses cepat',
  loginTitle: 'Raih kebebasan finansial Anda',
  loginDesc: 'Masuk disini untuk mengajukan pembukaan Deposito BPR. Belum punya akun? Silahkan Daftar sekarang sebagai deposan untuk melanjutkan.',
  tentangTitle: 'Tentang Kami',
  tentangDesc: 'Komunal berkomitmen untuk terus memberikan pelayanan yang terbaik, aman, dan nyaman untuk Anda. Hubungi Kami segera jika mengalami kendala.',
  kalkulatorTitle: 'Kalkulator Deposito: Simulasi Bunga Deposito Berjangka Bank BPR',
  kalkulatorDesc: 'Kalkulator deposito dapat membantu simulasikan hasil investasi anda, Tertarik melakukan deposito? Simulasikan deposito anda sekarang!',
  author: 'DepositoBPR by Komunal',
};
